module.exports = __webpack_public_path__ + "static/img/bg-2.2d0a71c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgaofu/bnaner/bg-2.png
// module id = kk9U
// module chunks = 0